/*
  This is a template for creating a Component class.

  Instructions: copy and paste this file into your newly created react component index.js. Then
  change the appropriate names and add your html render
    The base class for all components should be BaseClass (as indicated in this file)
    The base class insures that all call back handlers with "handle" in the name are bound
    to "this". This insures that "this" is defined as "this" for the containing class
*/

import React from 'react';
import _ from 'lodash';
import BaseComponent from '../../baseClasses/BaseComponent';
import dataModel from '../../models/DataModel';
import './BreadCrumbs.scss';

// Change BreadCrumbs to the appropriate name
class BreadCrumbs extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { breadCrumbsPath: dataModel.breadCrumbsPath ? dataModel.breadCrumbsPath : {}, taskName: this.props.taskName };
    this.mapBreadCrumbs = this.mapBreadCrumbs.bind(this);
    this.handleBackArrow = this.handleBackArrow.bind(this);
    this.updateBreadCrumbsPersisted = this.updateBreadCrumbsPersisted.bind(this);
  }

  updateBreadCrumbsPersisted(params) {
    const breadCrumbsPath = Object.assign({}, params);
    dataModel.breadCrumbsPath = breadCrumbsPath;
    this.setState({ breadCrumbsPath });
  }

  async handleInitialize() {
    const { history } = this.props;
    const { breadCrumbsPath } = this.state;
    const path = history.parseParameters();
    let selectedProjectTemplate;
    let selectedProject;
    let selectedBuild;
    let selectedTask;
    let taskIsSelected = false;
    let buildIsSelected = false;
    let projectIsSelected = false;
    if (path.params.project_id) {
      if (path.params.project_id != 'all') {
        if (!path.params.task_id) {
          projectIsSelected = true;
        }
        if (breadCrumbsPath.project_id != path.params.project_id) {
          this.updateBreadCrumbsPersisted(path.params);
        }
        selectedProject = await dataModel.projectsDAO.getProject(+path.params.project_id);
      }
    }
    else if (path.params.project_id) {
      if (path.params.build_id == 'all') {
        projectIsSelected = true;
        if (breadCrumbsPath.project_id != path.params.project_id) {
          this.updateBreadCrumbsPersisted(path.params);
        }
      }
      selectedProject = await dataModel.projectsDAO.getProject(+path.params.project_id, { recordDescriptor: { project: { builds: {} } } });
    }
    else if (path.params.project_template_id) {
      if (path.params.build_id == 'all') {
        projectIsSelected = true;
        if (breadCrumbsPath.project_template_id != path.params.project_template_id) {
          this.updateBreadCrumbsPersisted(path.params);
        }
      }
      selectedProjectTemplate = await dataModel.projectTemplatesDAO.getProjectTemplate(+path.params.project_template_id,
        { recordDescriptor: { project_template: { builds: {} } } });
    }
    if (path.params.build_id && path.params.build_id != 'all') {
      if (!path.params.task_id) {
        this.updateBreadCrumbsPersisted(path.params);
        buildIsSelected = true;
      }
      selectedBuild = await dataModel.buildsDAO.getBuild(+path.params.build_id);
    }
    else if (!path.params.project_id && breadCrumbsPath.build_id && breadCrumbsPath.build_id != 'all') {
      selectedBuild = await dataModel.buildsDAO.getBuild(+breadCrumbsPath.build_id);
    }
    if (path.params.task_id) {
      taskIsSelected = true;
      selectedTask = await dataModel.tasksDAO.getTask(+path.params.task_id, null, null, true);
      this.updateBreadCrumbsPersisted(path.params);
    }
    else if (breadCrumbsPath.task_id && breadCrumbsPath.build_id == path.params.build_id) {
      selectedTask = await dataModel.tasksDAO.getTask(+breadCrumbsPath.task_id, null, null, true);
      if (selectedBuild && selectedTask.build_id != selectedBuild.id) { 
        selectedBuild = null;
        this.updateBreadCrumbsPersisted(path.params);
      }
    }
    this.handleCreateBreadCrumbs(selectedProject, selectedProjectTemplate, selectedBuild, selectedTask, taskIsSelected, buildIsSelected, projectIsSelected);
  }

  componentDidMount() {
    let breadCrumbsPath = dataModel.breadCrumbsPath;
    const parsedPath = this.props.history.parseParameters();
    if (!_.isEqual(parsedPath.params, breadCrumbsPath)) {
      this.setState({ breadCrumbsPath: parsedPath.params }, () => {
        this.handleInitialize();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { history } = this.props;
    const { breadCrumbsPath } = this.state;

    const parsedPath = history.parseParameters();
    if (!_.isEqual(parsedPath.params, breadCrumbsPath)) {
      this.setState({ breadCrumbsPath: parsedPath.params }, () => {
        this.handleInitialize();
      });
    }
    if(prevProps.taskName !== this.state.taskName){
      this.handleInitialize();
      this.state.taskName = prevProps.taskName;
    }
  }

  componentWillUnmount(){
    if(dataModel.breadCrumbsPath){
      dataModel.breadCrumbsPath = null;
    }
  }

  handleBuildBreadCrumbClick(e) {
    const { selectedProject, selectedProjectTemplate, selectedBuild } = this.state;
    const dataIdStr = e.target.getAttribute('data-id') || e.currentTarget.getAttribute('data-id');

    if (dataIdStr) {
      const dataId = parseInt(dataIdStr, 10);

      let buildId;

      if (selectedBuild.id == dataId) {
        buildId = selectedBuild.id;
      }
      else{
        buildId = selectedProject.root_build_id;
      }
      if (selectedProject) {
        if (this.props.fromTasks) {
          dataModel.navigateUri = '/tasks/project/' + selectedProject.id;
        }
        else {
          dataModel.navigateUri = '/projects/' + selectedProject.id +
            '/build/' + buildId;
        }
      }
      else if (selectedProjectTemplate) {
        dataModel.navigateUri = '/project-types/' + selectedProjectTemplate.project_type_id + '/project-template/' + selectedProjectTemplate.id +
          '/build/' + buildId;
      }
    }
  }

  handleProjectBreadCrumbClick(e) {
    const { selectedProject, selectedProjectTemplate, breadCrumbsPath } = this.state;  
    const { history } = this.props;
    const path = history.parseParameters();
    const splittedPath = path.currentPath.split('/')[1];
    if(splittedPath === 'tasks'){
      this.props.history.push('/tasks/project/' + selectedProject.id);
    }
    else{
      if (selectedProject && breadCrumbsPath.project_id) {
        dataModel.navigateUri = '/projects/' + selectedProject.id;
      }
      else if (selectedProjectTemplate && breadCrumbsPath.project_template_id) {
        dataModel.navigateUri = '/project-types/' + selectedProjectTemplate.project_type_id + '/project-template/' + selectedProjectTemplate.id;
      }
    }
  }

  handleTaskBreakCrumbClick(e) {
    const { selectedTask, selectedProject, selectedProjectTemplate, selectedBuild } = this.state;
    if (selectedProject) {
      if (this.props.fromTasks) {
        dataModel.navigateUri = '/tasks/project/' + selectedProject.id;
      }
      else {
        dataModel.navigateUri = '/projects/' + selectedProject.id +
          '/build/' + (selectedBuild ? selectedBuild.id : selectedTask.build_id) + '/task/' + selectedTask.id;
      }
    }
    else if (selectedProjectTemplate) {
      dataModel.navigateUri = '/project-types/' + selectedProjectTemplate.project_type_id + '/project-template/' + selectedProjectTemplate.id + 
        '/build/' + (selectedBuild ? selectedBuild.id : selectedTask.build_id) + '/task/' + selectedTask.id;  
    }
  }

  mapBreadCrumbs(selectedProject, selectedProjectTemplate, selectedBuild, breadCrumbList) {
    if (selectedProject) {
      breadCrumbList = [{ id: selectedProject.root_build_id, name: selectedProject.name }];
      if (selectedBuild) {
        breadCrumbList.push(selectedBuild);
      }
      return breadCrumbList;
    }
    else if (selectedProjectTemplate) {
      breadCrumbList = [{ id: selectedProjectTemplate.root_build_id, name: selectedProjectTemplate.name }];
      if (selectedBuild) {
        breadCrumbList.push(selectedBuild);
      }
      return breadCrumbList;
    }
  }

  handleCreateBreadCrumbs(selectedProject, selectedProjectTemplate, selectedBuild, selectedTask, taskIsSelected, buildIsSelected, projectIsSelected) {
    if (selectedProject) {
      const breadCrumbList = selectedBuild ? this.mapBreadCrumbs(selectedProject, selectedProjectTemplate, selectedBuild, []) : [{ id: selectedProject.root_build_id, name: selectedProject.name }];
      const breadCrumbsSelector = breadCrumbList.map((innerBuild, index) => {
        if (innerBuild.id == selectedProject.root_build_id) {
          return (
            <div key={innerBuild.id + '_' + (index + 1)} data-id={innerBuild.id} className={'bread-crumb'}
              onClick={this.handleProjectBreadCrumbClick}>
              <p className="bread-crumb__name">{innerBuild.name}</p>{index < (breadCrumbList.length - 1) || selectedTask ? ' | ' : ''}
            </div>
          );
        }
        else {
          return (
            <div key={innerBuild.id + '_' + (index + 1)} data-id={innerBuild.id} className={'bread-crumb ' + (buildIsSelected ? 'selected' : '')}
              onClick={this.handleBuildBreadCrumbClick}>
              <p className="bread-crumb__name">{innerBuild.name}</p>{(index < (breadCrumbList.length - 1) || selectedTask) ? ' | ' : ''}
            </div>
          );
        }
      });

      if (selectedTask) {
        breadCrumbList.push(selectedTask);
        breadCrumbsSelector.push(
          <div key={selectedTask.id + '_' + 0} data-id={selectedTask.id} className={'bread-crumb ' + (taskIsSelected ? 'selected' : '')}
            onClick={!taskIsSelected ? this.handleTaskBreakCrumbClick : null}>
            <p className="bread-crumb__name">{this.state.taskName && this.state.taskName}</p>{' '}
          </div>
        );
      }

      const breadCrumbs = <div className="bread-crumbs">{breadCrumbsSelector}</div>;
      this.setState({ breadCrumbs, selectedProject, selectedProjectTemplate, selectedBuild, selectedTask, projectIsSelected, buildIsSelected, taskIsSelected });
    }
    else if (selectedProjectTemplate) {
      const breadCrumbList = selectedBuild ? this.mapBreadCrumbs(selectedProject, selectedProjectTemplate, selectedBuild, []) : [{ id: selectedProjectTemplate.root_build_id, name: selectedProjectTemplate.name }];
      const breadCrumbsSelector = breadCrumbList.map((innerBuild, index) => {
        if (innerBuild.id == selectedProjectTemplate.root_build_id) {
          return (
            <div key={innerBuild.id + '_' + (index + 1)} data-id={innerBuild.id} className={'bread-crumb ' + (projectIsSelected ? 'selected' : '')}
              onClick={this.handleProjectBreadCrumbClick}>
              <p className="bread-crumb__name">{innerBuild.name}</p>{index < (breadCrumbList.length - 1) || selectedTask ? ' | ' : ''}
            </div>
          );
        }
        else {
          return (
            <div key={innerBuild.id + '_' + (index + 1)} data-id={innerBuild.id} className={'bread-crumb ' + (buildIsSelected ? 'selected' : '')}
              onClick={this.handleBuildBreadCrumbClick}>
              <p className="bread-crumb__name">{innerBuild.name}</p>{(index < (breadCrumbList.length - 1) || selectedTask) ? ' | ' : ''}
            </div>
          );
        }
      });

      if (selectedTask) {
        breadCrumbList.push(selectedTask);
        breadCrumbsSelector.push(
          <div key={selectedTask.id + '_' + 0} data-id={selectedTask.id} className={'bread-crumb ' + (taskIsSelected ? 'selected' : '')}
            onClick={!taskIsSelected ? this.handleTaskBreakCrumbClick : null}>
            <p className="bread-crumb__name">{selectedTask.name}</p>{' '}
          </div>
        );
      }

      const breadCrumbs = <div className="bread-crumbs">{breadCrumbsSelector}</div>;
      this.setState({ breadCrumbs, selectedProject, selectedProjectTemplate, selectedBuild, selectedTask, projectIsSelected, buildIsSelected, taskIsSelected });
    }
  }

  handleBackArrow() {
    const { history } = this.props;
    const { selectedProject, selectedProjectTemplate, breadCrumbsPath, selectedBuild } = this.state;  
    const path = history.parseParameters();
    const splittedPath = path.currentPath.split('/');
    const oldPath = history._paths.length >= 2 && history._paths[history._paths.length-2].pathname;
    const splittedOldPath = oldPath && oldPath.split('/');
    if(splittedPath[1] === 'tasks'){
      if(splittedOldPath && splittedOldPath[3] !== 'all'){
        this.props.history.push(`/tasks/project/${splittedPath[3]}`);
      }
      else{
        this.props.history.push('/tasks/project/all');
      }
    }
    else{
      if(path.params.task_id){
        if (selectedProject && breadCrumbsPath.project_id) {
          dataModel.navigateUri = '/projects/' + selectedProject.id +
              '/build/' + selectedBuild.id;
        }
        else if (selectedProjectTemplate && breadCrumbsPath.project_template_id) {
          dataModel.navigateUri = '/project-types/' + selectedProjectTemplate.project_type_id + '/project-template/' + selectedProjectTemplate.id +
          '/build/' + selectedBuild.id;      }
      }
      else{
        if (selectedProject && breadCrumbsPath.project_id) {
          dataModel.navigateUri = '/projects/' + selectedProject.id;
        }
        else if (selectedProjectTemplate && breadCrumbsPath.project_template_id) {
          dataModel.navigateUri = '/project-types/' + selectedProjectTemplate.project_type_id + '/project-template/' + selectedProjectTemplate.id;
        }
      }
    }
  }

  render() {
    const { breadCrumbs } = this.state;
    if (!breadCrumbs) {
      return null;
    }
    return (
      <div className="bread-crumb-list">
      <div className="back-arrow" onClick={this.handleBackArrow} />
        {breadCrumbs}
        {this.props.menu}
      </div>
    );
  }
}

export default (BreadCrumbs);



// WEBPACK FOOTER //
// ./src/components/BreadCrumbs/index.js